import { createComponentMapperModel } from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import {
  props as stylableButtonMapperProps,
  css,
  sdkData,
} from '../../../StylableButton/viewer/StylableButton.mapper';
import { ARIA_LABEL_NAMESPACE, TranslationKeys } from '../../constants';
import type {
  StylableButtonPlatformProps,
  StylableButtonDefinition,
  StylableButtonCarmiProps,
} from '../../../StylableButton/StylableButton.types';

const props = composeMapper<
  StylableButtonPlatformProps,
  StylableButtonDefinition,
  StylableButtonCarmiProps
>()(
  stylableButtonMapperProps,
  { add: ['translate'] },
  (resolver, deps, carmiData) => {
    const { translate, ...viewerDeps } = deps;
    const viewerProps = resolver(viewerDeps, carmiData);
    return {
      ...viewerProps,
      translations: {
        ariaLabelNext: translate(
          ARIA_LABEL_NAMESPACE,
          TranslationKeys.ariaLabels.nextAriaLabel,
        ),
        ariaLabelPrev: translate(
          ARIA_LABEL_NAMESPACE,
          TranslationKeys.ariaLabels.prevAriaLabel,
        ),
      },
    };
  },
);

export default createComponentMapperModel({
  props,
  css,
  sdkData,
});
